import { useLocation } from '@tanstack/react-router';

export const useSearchParams = () => {
  const location = useLocation();

  const getRedirectUrl = () => {
    const urlParams = new URLSearchParams(location.search);
    return urlParams.get('redirect_url') || '';
  };

  const createSearchParams = (params: Record<string, string>, preserve: boolean = true) => {
    // Start with existing params if preserve is true
    const result: Record<string, string> = {};

    if (preserve) {
      const existingParams = new URLSearchParams(location.searchStr);
      existingParams.forEach((value, key) => {
        result[key] = value;
      });
    }

    // Add/update with new params
    Object.entries(params).forEach(([key, value]) => {
      result[key] = value;
    });

    return result;
  };

  return { getRedirectUrl, createSearchParams };
};
